var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_vm._v("4")])
}
var staticRenderFns = []

export { render, staticRenderFns }